import _typeof from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import { mapState, mapActions } from 'vuex';
import fieldChange from '@/mixins/el-field-change';
import multiple from '@/mixins/component-multiple';
export default {
  mixins: [fieldChange, multiple],
  data: function data() {
    return {
      currentValue: '',
      options: []
    };
  },
  props: {
    // 绑定的值
    // 注意 这里不能默认值是 null
    // https://github.com/ElemeFE/element/issues/8615
    // 字典是数字类型的请在外部设置默认 0 字符设置默认空字符串
    value: {
      type: [Number, String, Array],
      default: '',
      required: false
    },
    // 字典名
    name: {
      type: String,
      default: '',
      required: false
    },
    // [自动加载字典] 自定义字典数据 设置为 false 时会自动加载对应名称的字典
    custom: {
      type: Boolean,
      default: false,
      required: false
    },
    // [全部] 选项
    all: {
      type: Boolean,
      default: false,
      required: false
    },
    // [全部] 选项 标题
    allLabel: {
      type: String,
      default: 'all',
      required: false
    },
    // [全部] 选项 值
    allValue: {
      type: [Number, String],
      default: undefined,
      required: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('d2admin/dict', ['dicts'])), {}, {
    currentLabel: function currentLabel() {
      var _this = this;

      if (this.multiple) {
        var num = this.tryParseMultipleString(this.value).length;
        return "".concat(num, " items");
      } else {
        var item = this.options.find(function (e) {
          return e.value === _this.value;
        });
        return item ? item.label : '';
      }
    },
    attrs: function attrs() {
      var _this2 = this;

      var defaultAttrs = {
        placeholder: 'please choose'
      };
      var item = this.options.find(function (e) {
        return e.value === _this2.value;
      });

      if (item) {
        defaultAttrs.style = item.css_class + ':' + item.list_class;
      }

      return Object.assign(defaultAttrs, this.$attrs);
    }
  }),
  watch: {
    dicts: function dicts() {
      this.reload();
    },
    name: {
      handler: function handler() {
        if (!this.custom) this.fetch();
        this.reload();
      },
      immediate: true
    },
    value: {
      handler: function handler(value) {
        this.currentValue = this.tryParseMultipleString(value);
      },
      immediate: true
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/dict', {
    dictGet: 'get',
    dictFetch: 'fetch'
  })), {}, {
    fetch: function fetch() {
      this.dictFetch(this.name);
    },
    reload: function reload() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var options;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _this3._;
                _context.next = 3;
                return _this3.dictGet(_this3.name);

              case 3:
                _context.t1 = _context.sent;
                options = _context.t0.cloneDeep.call(_context.t0, _context.t1);

                // 需要有默认值选项
                if (_this3.all) {
                  // 默认值选项
                  options.unshift({
                    label: _this3.allLabel,
                    value: function () {
                      // 组件设置了默认值的值
                      if (_this3.allValue !== undefined) return _this3.allValue; // 组件没有设置默认值的值
                      else {
                          // 工具方法 如果是 undefined 就返回第二个参数
                          var valueOr = function valueOr(v, d) {
                            return v === undefined ? d : v;
                          }; // 推算默认值使用的类型默认值设置


                          var settign = {
                            number: valueOr(_this3.$env.VUE_APP_DICT_EMPTY_NUMBER, 0),
                            string: valueOr(_this3.$env.VUE_APP_DICT_EMPTY_STRING, '')
                          }; // 允许的字典值类型

                          var allow = Object.keys(settign); // 字典的数据类型

                          var type = allow[0];

                          if (options.length > 0) {
                            // 第一个选项值的数据类型
                            var type0 = _typeof(options[0].value); // 如果数据类型在允许的范围内 更新外层的字典数据类型


                            if (allow.indexOf(type0) >= 0) type = type0;
                          }

                          return settign[type];
                        }
                    }()
                  });
                }

                _this3.options = options;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onChange: function onChange(value) {
      var result = this.tryStringify(value);
      this.$emit('input', result);
      this.$emit('change', result);
      this.fieldChange();
    }
  })
};